export default "__VITE_ASSET__Rmoz4zQF__"